// firebase.ts
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';


const firebaseConfig = {
    apiKey: "AIzaSyD_kVfacM6gKBcdEjTplWV2vAvdo3Hadxo",
    authDomain: "roundup-b0b41.firebaseapp.com",
    projectId: "roundup-b0b41",
    storageBucket: "roundup-b0b41.appspot.com",
    messagingSenderId: "737896812371",
    appId: "1:737896812371:web:5fb4534fd3d7a2b4cd5ba6",
    measurementId: "G-GL9FK3ZF35"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);


export { app, db, auth, RecaptchaVerifier, signInWithPhoneNumber };